import { render, staticRenderFns } from "./ReportComposition.vue?vue&type=template&id=be9b8af2&scoped=true"
import script from "./ReportComposition.vue?vue&type=script&lang=js"
export * from "./ReportComposition.vue?vue&type=script&lang=js"
import style0 from "./ReportComposition.vue?vue&type=style&index=0&id=be9b8af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9b8af2",
  null
  
)

export default component.exports